import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";

export type BillingCheckoutSessionResponse = {
  id: string;
  client_secret: string;
};

export async function createBillingCheckoutSession(args?: {
  returnUrl?: string;
}): Promise<BillingCheckoutSessionResponse> {
  return await pmFetchJson<BillingCheckoutSessionResponse>("/billing/checkout-session", {
    method: "POST",
    body: {
      return_url: args?.returnUrl,
    },
  });
}

export type BillingCheckoutStatusResponse = {
  session_id: string;
  setup_intent_id?: string | null;
  checkout_session?: {
    id?: string | null;
    status?: string | null;
    payment_status?: string | null;
    mode?: string | null;
  };
  setupIntent?: {
    id: string;
    payment_method?: string | null;
    status?: string | null;
    cancellation_reason?: string | null;
    last_setup_error?: {
      code?: string | null;
      decline_code?: string | null;
      message?: string | null;
      type?: string | null;
    } | null;
  };
};

export async function fetchBillingCheckoutStatus(args: {
  sessionId: string;
}): Promise<BillingCheckoutStatusResponse> {
  return await pmFetchJson<BillingCheckoutStatusResponse>(`/billing/checkout/${encodeURIComponent(args.sessionId)}`, {
    method: "GET",
  });
}

export async function fetchBillingPaymentMethod(args: { id: string }): Promise<any> {
  return await pmFetchJson<any>("/billing/payment-method", {
    method: "GET",
    params: { id: args.id },
  });
}

// Sets users.save_billing; false also removes the user's Stripe default
// payment method server-side (legacy parity — same endpoint the Angular
// attach checkbox used).
export async function toggleSaveBilling(args: { save: boolean }): Promise<void> {
  await pmFetchJson("/billing/toggle-save", {
    method: "POST",
    body: { save_billing: args.save },
  });
}

// No id: the server returns the user's default payment method (or nothing).
export async function fetchDefaultPaymentMethod(): Promise<any> {
  return await pmFetchJson<any>("/billing/payment-method", {
    method: "GET",
  });
}
